import httpService from "../../components/service";

export const list = {
    namespaced: true,
    state: {
        baskets: []
    },
    getters: {
        getListBasket: state => state.baskets,
        getMenuList: state => state.baskets.slice(0, 5),
        countAllBaskets: state => state.baskets.length
    },
    mutations: {
        SET_LIST_BASKET(state, data) {
            state.baskets = data;
        },
        ADD_BASKET(state, basket) {
            state.baskets.push(basket);
        },
        REMOVE_BASKET(state, basketId) {
            let basketIndex = state.baskets.findIndex(basket => basket.id === basketId);
            state.baskets.splice(basketIndex, 1);
        }
    },
    actions: {
        async populateBasketList(context) {
            const res = await httpService.get("/baskets?limit=50");
            context.commit("SET_LIST_BASKET", res.data);
            return res;
        },
        async addBasket(context, basket) {
            const res = await httpService.post("/baskets", JSON.stringify(basket));
            context.commit("ADD_BASKET", res);
            return res;
        },
        async deleteBasket(context, basketId) {
            const res = await httpService.delete("/baskets/" + basketId + "/delete");
            context.commit("REMOVE_BASKET", basketId);
            return res;
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/basket/list.js